<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const defaults = {
	title: 'Please Support Us',
	goalMeterPlaceholder: '',
	content: '',
	donationFormPlaceholder:
		'<iframe frameborder="none" src="https://thetorah.app.neoncrm.com/forms/11" width="100%" height="700"></iframe>',
	footer: '',
}
const schema = defineSchema({
	title: $.text('Title'),
	goalMeterPlaceholder: $.text('Goal Meter', { multiline: true, rows: 4 }),
	content: $.richtext('Content'),
	donationFormPlaceholder: $.text('Donation Form', { multiline: true, rows: 4 }),
	footer: $.text('Footer'),
})
export const BlockDonate = defineBlock({
	thumbnail: '/block-thumbs/BlockDonate.svg',
	category: 'CTA',
	order: 210,
	name: 'BlockDonate',
	label: 'Donate',
	icon: 'volunteer_activism',
	schema,
	defaults,
})
</script>
<script setup lang="ts">


import RichHtml from '@/components/RichHtml.vue'




defineProps<{
	title?: string
	goalMeterPlaceholder?: string
	content?: string
	donationFormPlaceholder?: string
	footer?: string
}>()
</script>

<template>
	<div class="w1000px py-3 m_px-1 pageHeight">
		<div class="grid grid-wrap-2 gap-3">
			<div>
				<h1 class="txt29 regular line-height-14 m_txt24 my-0 m_txt-center pb-1">
					{{ title }}
				</h1>

				<RichHtml :html="goalMeterPlaceholder" />
				<div class="txt17 light line-height-18 pt-1" v-html="content" />
			</div>

			<RichHtml :html="donationFormPlaceholder" />
		</div>
		<i class="txt-center txt12 pt-3 block">
			{{ footer }}
		</i>
	</div>
</template>
